import { render, h } from 'preact'
// import Index from './pages/home.search'
// import Index from './pages/ordershow'
import Index from './pages/home.cct'
import './style.scss'

export default function createApp() {
  const container = document.createElement('div')
  container.id = 'app'
  document.body.appendChild(container)

  render(<Index demoid="He6sCPycwP86kgQcK" type="home" />, container)
}

"undefined" != typeof wx && wx.getSystemInfoSync || createApp()
